/**
 * Kanoniska länkar. userId → /profile/:userId och venueId → /venue/:venueId.
 *
 * Allt som pekar på en person eller ett ställe bygger sin länk här, så att
 * inget UI-flöde uppfinner en egen väg dit.
 */
export const profilePath = (userId: string) =>
  `/profile/${encodeURIComponent(userId)}`;

export const venuePath = (venueId: string) =>
  `/venue/${encodeURIComponent(venueId)}`;
